export const POST_CREDIT_DEBIT_DATA_EXPORT_API = 'POST_CREDIT_DEBIT_DATA_EXPORT_API'
export const POST_CREDIT_DEBIT_DATA_EXPORT_API_SUCCESS = 'POST_CREDIT_DEBIT_DATA_EXPORT_API_SUCCESS'

export const POST_CREDIT_DEBIT_DATA_EXPORT_API_ERROR_ACTION = 'POST_CREDIT_DEBIT_DATA_EXPORT_API_ERROR_ACTION'
